import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Address } from "../../common/_types/address";
import { File } from "../../common/_types/file";

export class Business extends Resource {
    public override type = 'businesses';

    @prop()
    @required()
    public name!: string;

    @prop()
    @required()
    public legalName!: string;

    @prop()
    public email!: string;

    @prop()
    public phone1!: string;

    @prop()
    public phone2!: string;

    @prop()
    @required()
    public active: boolean = true;

    @prop()
    public vatNumber!: string;

    @prop()
    public addressId!: string;

    @propObject(Address)
    public address: Address = new Address();

    @prop()
    public logoId!: string | null ;

    @prop()
    public commercialRegister?: string;

    @prop()
    public certificateFileId!: string | null;

    public certificateFile!: File;
    
    @prop()
    public certificateFilePassword?:string;

}